module.exports = __webpack_public_path__ + "static/arveiaturace-7d32d6f93cadc49e2e0fcbe42eaba7fd.jpg";